import { useEffect, useState, useRef } from "react"
import { getPlantillaSencilla,  } from '../componentes/api.js';
import TextField from '@mui/material/TextField';
import BarraBotones from "../comun/BarraBotones.jsx";
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Table from 'react-bootstrap/Table';

import {RUTA_SERVIDOR} from '../componentes/config.js';

const PlantillaSencilla =(props)=>{
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [cargando, setCargando] = useState(false)
  const [datos, setDatos] = useState([])
  const [cant, setCant] = useState(0)
  const [registro, setRegistro] = useState({
    Id:'',
    Nbre:'',
    Activo: true
  });
  
  useEffect(() =>{
    cargarDatos();
    nuevo()
  },[props.tabla, props.titulo]);

  const asignarDato =(event)=>{
    event.preventDefault();
    if(event.target.name === 'Activo'){
      setRegistro({...registro, [event.target.name]: event.target.checked})

    }else{
      setRegistro({...registro, [event.target.name]: event.target.value})
    }
    
  }

  const cargarDatos = async()=>{
    try {
      const response = await getPlantillaSencilla(props.tabla)
      setDatos(response.data)
      setCant(response.data.length)
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al cargar los datos en el Grid", error])
    }
  }

  const botones=(btn)=>{
    if(btn===0) nuevo();
    else if(btn===1) validarDatos();
    else if(btn===2) imprimir();
    else if(btn===3) exportar();
    else if(btn===4) nuevo();
    scrollToElement()
  }

  const imprimir =()=>{
    props.mostrarMsg(["OK, Imprime los datos"])
  }

  const exportar =()=>{
    props.mostrarMsg(["OK, exportará los datos"])
  }
  
  const cargarFila = (event, reg)=>{
    event.preventDefault();
    setRegistro({
      ['Id']: reg.Id,
      ['Nbre']: reg.Nbre,
      ['Activo']: reg.Activo==='Activo' ? 1 : 0})
      scrollToElement()
  }

  const validarDatos = ()=>{
    if(registro.Nbre===''){
      props.mostrarMsg(["Por favor digite el Nombre"])

    }else{
      {registro.Id==='' ? grabarRegistro() : modificarRegistro()}
    }

  }

  const grabarRegistro = async()=>{
    try {
      let dato ={Id: registro.Id, Nbre: registro.Nbre, Activo: registro.Activo? 1:0, Tabla: props.tabla, IdUsuario: props.idUsuario}
      const reg = await fetch(RUTA_SERVIDOR + 'setPlantillaSencilla', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dato),
      });

      const propues = await reg.json();
      if (propues.toString().length > 0) {
        setRegistro({...registro, ['Id']: propues.Id})
        cargarDatos();
        props.mostrarMsg(["Felicidades!!!", "Registro Grabado!"])


      } else {
        props.mostrarMsg(['Ocurrió un error al Grabar!']);
      }

      setCargando(false)
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(['Ocurrió un error al Grabar!']);
    }
  }


  const modificarRegistro = async()=>{
    try {
      let dato ={Id: registro.Id, Nbre: registro.Nbre, Activo: registro.Activo, Tabla: props.tabla, IdUsuario: props.idUsuario}
      const reg = await fetch(RUTA_SERVIDOR + 'updatePlantillaSencilla', {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dato),
      });

      const propues = await reg.json();
      if(propues.result.affectedRows===1){
        cargarDatos();
        props.mostrarMsg(["Felicidades!!!", "Registro Modificado!"])

      } else {
        props.mostrarMsg(['Ocurrió un error al Modificar los datos!']);
      }

      setCargando(false)
    } catch (error) {
      setCargando(false);
      props.mostrarMsg(['Ocurrió un error al Modificar el registro']);
    }
  }

  const nuevo =()=>{
    setRegistro({
      Id:'',
      Nbre:'',
      Activo: true
    })
  }

  return(
    <div className="container-fluid"ref={testRef}>
      <div className="row card">
        <Alert severity="success"><strong>{props.titulo}</strong>
          {cargando===true &&
            <div className="spinner-grow text-primary" role="status">
              <span className="visually">Cargando...</span>
            </div>
          }
        </Alert>

        <div className="row mt-3">
          <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
        </div>

        <div className="row mb-3 m-0">
          <TextField
            name="Id"
            label="ID"
            className="form-control"
            type="text"
            value={registro.Id}
            disabled
          />
        </div>

        <div className="row mb-3 m-0">
          <TextField
            autoFocus={true}
            name="Nbre"
            label="Nombre"
            className="form-control"
            type="text"
            value={registro.Nbre}
            onChange={asignarDato}
          />
        </div>


        <div className="row mt-3">
          <div className="form-check form-switch m-3">
            <input 
              className="form-check-input" 
              type="checkbox" 
              role="switch" 
              name="Activo" 
              size={'large'}
              checked={registro.Activo}
              onChange={asignarDato}
            />
            <label 
              className="form-check-label text-end" 
              htmlFor="Activo"
            >
              {registro.Activo===true ? "Estado: ACTIVO" : "Estado: ANULADO" }
            </label>
          </div>
        </div>  
      </div>
        
      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
      </div>

        
      <div className="row card">
        <h3 className="mt-3 mb-3">LISTADO - Cantidad: {cant}</h3>
        <Table className="table table-hover table-bordered" responsive>
          <thead className="table-primary">
            <tr>
              <th scope="col"># ITEM</th>
              <th scope="col">NOMBRE</th>
              <th scope="col" className="text-center">ESTADO</th>
              <th scope="col" className="text-center">ACCION</th>
            </tr>
          </thead>
          <tbody>
            {datos.map((reg, i)=>{
              return(
              <tr className={reg.Activo==='Inactivo'? "table-danger":""} key={i}>
                <th> {i+1} </th>
                <th> {reg.Nbre} </th>
                <th> {reg.Activo} </th>
                <th> 
                  <a href="divTop"
                    className="btn btn-primary form-control"
                    onClick={(event) =>{cargarFila(event, reg)}}
                  >Editar 
                  </a>
                </th>
              </tr>
              )})} 
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default PlantillaSencilla